module.exports = __webpack_public_path__ + "static/img/smartstation43.3ac69867.png";